import React, { Fragment, memo, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Save, Add, DoneAll } from '@material-ui/icons';

import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Avatar from '@material-ui/core/Avatar';

import { Select, MenuItem, TextField, FormControlLabel, Checkbox } from '@material-ui/core';
import { wsFindBy, wsCreate, wsUpdate } from 'services/WService.js';
import moment from 'moment';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';

const useStyles = makeStyles((theme) => ({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  inputPersonalize: {
    display: 'flex',
    transform: 'translate(0px, -11px)',
    '& label': {
      paddingTop: '13px'
    }
  }
}));

const ruleTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'ID', accessor: 'id', width: 80 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'CMR', accessor: 'ehr', width: 90 },
  { Header: 'Fecha inicio', accessor: 'start_date', width: 110 },
  { Header: 'Fecha final', accessor: 'end_date', width: 110 },
  { Header: 'Priori.', accessor: 'priority', width: 90 },
  { Header: 'Acumu.', accessor: 'cumulative', width: 80 },
  { Header: 'Cantidad', accessor: 'quantity', width: 130 },
  { Header: 'Cant. T.', accessor: 'quantity_group', width: 90 },
  { Header: 'Avce.', accessor: 'rule_advance', width: 80 },
  { Header: 'Límit', accessor: 'rule_limit', width: 80 },
  { Header: 'Estado', accessor: 'state', width: 90 },
  { Header: 'Acciones', accessor: 'actions', excelEnabled: false, width: 100 }
];

function Rules({ promotion, setRule, setPromotion }) {
  const classes = useStyles();
  const [focusRuleId, setFocusRuleId] = useState(null);
  const [notify, showNotify] = useToasty();
  const [processing, setProcessing] = useState(false);

  const statePromo = promotion.state == 'N' || promotion.state == 'G' ? false : true;

  const [rules, setRules] = useState([]);
  const [ehrs, setEhrs] = useState([]);

  async function listEhrs() {
    let response = await wsFindBy('base/state', 'code', 'TCMR');
    if (response.success) setEhrs(response.data);
  }

  async function updatePromotionCombo(combo) {
    setProcessing(true);
    let res = await wsUpdate('prom/promotion', promotion.id, { account_combo_product: combo });
    setProcessing(false);
    if(res.success){
      showNotify(res.message);
      setPromotion(promotion => ({...promotion, account_combo_product: res.data.account_combo_product}))
    }else{
      showNotify(res.message, 'error');
    }
  }

  async function createRule() {
    let response = await wsCreate('prom/rule', {
      prom_promotion_id: promotion.id,
      ehr: 'E',
      qry_min: promotion.condition === 'Q' ? 1 : 1,
      qry_max: 0,
      /* priority: 0, */
      cumulative: 0,
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().endOf('month').format('YYYY-MM-DD'),
      quantity_group: 0
    });
    if (response.success) {
      showNotify(response.message);
      listRules();
    } else {
      showNotify(response.message, 'error');
    }
  }

  const [dataRule, setDataRule] = useState();

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setDataRule({ ...dataRule, [name]: value });
    setRules((rules) => {
      let newRules = [...rules];
      let ruleIndex = newRules.findIndex((rule) => rule.id === focusRuleId);
      newRules[ruleIndex] = { ...newRules[ruleIndex], [name]: value };
      return newRules;
    });
  };

  async function updateRule(focusRuleId, dataRule) {
    let response = await wsUpdate('prom/rule', focusRuleId, dataRule);
    if (response.success) {
      showNotify(response.message);
      setDataRule(undefined);
      listRules(true);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function listRules(param) {
    let response = await wsFindBy('prom/rule', 'prom_promotion_id', promotion.id);
    if (response.success) {
      setRules(response.data);
      if (response.data.length > 0) {
        setRule(response.data[0]);
        if (param === undefined) {
          setFocusRuleId(response.data[0].id);
        }
      }
    }
  }

  useEffect(() => {
    if (!!promotion.id) {
      listRules();
      listEhrs();
    }
  }, [promotion]);

  return (
    <Fragment>
      <Toasty action={notify} />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon
              color="success"
              pointer="true"
              onClick={statePromo === false ? createRule : undefined}
            >
              <Add />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              <span style={{ marginRight: '100px' }}>Reglas</span>
              <FormControlLabel
                label="Producto combo"
                disabled={processing || statePromo}
                control={
                  <Checkbox
                    margin="normal"
                    disabled={processing || statePromo}
                    checked={promotion.account_combo_product}
                    onChange={(e) => updatePromotionCombo(e.target.checked)}
                  />
                }
              />
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              exportExcel={false}
              heightRow={55}
              defaultWidth={1500}
              columns={ruleTableColumns}
              data={rules.map((rule, i) => {
                return {
                  num:
                    dataRule !== undefined ? (
                      focusRuleId == rule.id ? (
                        <Avatar alt="Remy Sharp" src="/img/pencil.gif" variant="square" />
                      ) : (
                        ''
                      )
                    ) : (
                      <Button
                        justIcon
                        round
                        size="sm"
                        color={focusRuleId == rule.id ? 'primary' : 'transparent'}
                        onClick={() => {
                          setRule(rule);
                          setFocusRuleId(rule.id);
                          setDataRule(undefined);
                        }}
                      >
                        <DoneAll />
                      </Button>
                    ),
                  id: rule.id.toString(),
                  description: (
                    <TextField
                      name="description"
                      onChange={handleChange}
                      value={rule.description}
                      disabled={statePromo || focusRuleId !== rule.id}
                      fullWidth
                    />
                  ),
                  ehr: (
                    <Select
                      value={rule.ehr || 'E'}
                      inputProps={{
                        name: 'ehr',
                      }}
                      fullWidth
                      disabled={statePromo || focusRuleId !== rule.id}
                    >
                      {ehrs.map((ehr, i) => {
                        return (
                          <MenuItem
                            key={i}
                            value={ehr.value}
                            onClick={(e) => {
                              updateRule(rule.id, { ehr: ehr.value });
                            }}
                          >
                            {ehr.text}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ),
                  /* prom_rule_id: (
                    <TextField
                      type="number"
                      name="prom_rule_id"
                      onChange={handleChange}
                      defaultValue={rule.prom_rule_id}
                      inputProps={{ min: 0 }}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ), */
                  start_date: (
                    <TextField
                      type="date"
                      name="start_date"
                      onChange={handleChange}
                      value={rule.start_date}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  end_date: (
                    <TextField
                      type="date"
                      name="end_date"
                      onChange={handleChange}
                      value={rule.end_date}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  priority: (
                    <TextField
                      type="number"
                      name="priority"
                      onChange={handleChange}
                      value={rule.priority}
                      inputProps={{ min: 0 }}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  cumulative: (
                    <TextField
                      type="number"
                      name="cumulative"
                      onChange={handleChange}
                      value={rule.cumulative}
                      inputProps={{ min: 0 }}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  quantity: (
                    <div className={classes.inputPersonalize}>
                      {rule.ehr == 'R' ? (
                        <Fragment>
                          <TextField
                            type="number"
                            name="qry_min"
                            placeholder="Min"
                            label="Min"
                            onChange={handleChange}
                            value={rule.qry_min}
                            inputProps={{ min: 0, step: promotion.condition === 'Q' ? 1 : 0.01 }}
                            disabled={statePromo || focusRuleId !== rule.id}
                          />
                          <TextField
                            type="number"
                            name="qry_max"
                            placeholder="Max"
                            label="Max"
                            onChange={handleChange}
                            value={rule.qry_max}
                            inputProps={{ min: 0, step: promotion.condition === 'Q' ? 1 : 0.01 }}
                            style={{ marginLeft: '5px' }}
                            disabled={statePromo || focusRuleId !== rule.id}
                          />
                        </Fragment>
                      ) : (
                        <TextField
                          type="number"
                          name="qry_min"
                          placeholder="Min"
                          label="Min"
                          onChange={handleChange}
                          value={rule.qry_min}
                          inputProps={{ min: 0, step: promotion.condition === 'Q' ? 1 : 0.01 }}
                          margin="none"
                          disabled={statePromo || focusRuleId !== rule.id}
                        />
                      )}
                    </div>
                  ),
                  quantity_group: (
                    <TextField
                      type="number"
                      name="quantity_group"
                      onChange={handleChange}
                      value={rule.quantity_group}
                      inputProps={{ min: 0 }}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  rule_advance: (
                    <TextField
                      type="number"
                      name="rule_advance"
                      onChange={handleChange}
                      value={rule.rule_advance}
                      inputProps={{ min: 0 }}
                      disabled
                    />
                  ),
                  rule_limit: (
                    <TextField
                      type="number"
                      name="rule_limit"
                      onChange={handleChange}
                      value={rule.rule_limit}
                      inputProps={{ min: 0 }}
                      disabled={statePromo || focusRuleId !== rule.id}
                    />
                  ),
                  state: (
                    <Select
                      value={rule.state}
                      inputProps={{
                        name: 'state',
                      }}
                      fullWidth
                      disabled={statePromo || focusRuleId !== rule.id}
                    >
                      <MenuItem
                        value="A"
                        onClick={(e) => {
                          updateRule(rule.id, { state: 'A' });
                        }}
                      >
                        Activo
                      </MenuItem>
                      <MenuItem
                        value="I"
                        onClick={(e) => {
                          updateRule(rule.id, { state: 'I' });
                        }}
                      >
                        Inactivo
                      </MenuItem>
                    </Select>
                  ),
                  actions: (
                    <div className="actions-right">
                      <Button
                        justIcon
                        round
                        size="sm"
                        color="success"
                        onClick={() => updateRule(rule.id, dataRule)}
                        className={classes.marginRight}
                        disabled={statePromo || focusRuleId !== rule.id}
                      >
                        <Save className={classes.icons} />
                      </Button>
                      <ButtonDelete
                        entity="prom/rule"
                        id={rule.id}
                        reload={listRules}
                        disabled={statePromo}
                      />
                    </div>
                  ),
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
}

export default memo(Rules);
